import { BusinessProduct } from "@1games-ru/region-shared/dist/backend/requests/business";
import { useCallback, useEffect, useState } from "react";
import useGetServerDateAndTimeWithDiff from "@/core/helpers/useGetServerDateAndTimeWithDiff";
import useUnlockTimer from "@/domains/business/hooks/useUnlockTimer";
import BusinessPricesForServicessServiceCard from "@/domains/business/components/pricesForServices/BusinessPricesForServicessServiceCard";

type Props = {
  src: string;
  item: BusinessProduct;
  setExtraCharge: (
    productId: number,
    percent: number,
    setIsAccept: (arg0: boolean) => void,
  ) => void;
  isUpdating: boolean;
};

export default function BusinessPricesForServicessServiceCardContainer({
  src,
  item,
  setExtraCharge,
  isUpdating,
}: Props) {
  const [isAccept, setIsAccept] = useState(false);
  const [selectedValue, setSelectedValue] = useState(item.percent);

  const { fetchServerTimeIso } = useGetServerDateAndTimeWithDiff();

  const { isLocked, remainingTime, isHour } = useUnlockTimer(item.pricedAt, fetchServerTimeIso);

  useEffect(() => {
    setSelectedValue(item.percent);
  }, [item.percent]);

  const handleValueChange = useCallback((newValue: number) => {
    setSelectedValue(newValue);
  }, []);

  const handleSetIsAccept = useCallback((value: boolean) => {
    setIsAccept(value);
  }, []);

  return (
    <BusinessPricesForServicessServiceCard
      src={src}
      item={item}
      setExtraCharge={setExtraCharge}
      isUpdating={isUpdating}
      isLocked={isLocked}
      isHour={isHour}
      remainingTime={remainingTime}
      selectedValue={selectedValue}
      min={item.minPercent}
      max={item.maxPercent}
      handleValueChange={handleValueChange}
      isAccept={isAccept}
      setIsAccept={handleSetIsAccept}
    />
  );
}
